"use client";
import dynamic from "next/dynamic";

export const ContentfulInspectorManager = dynamic(
  async () => {
    const React = await import("react");
    const { useContentfulInspectorMode } = await import(
      "@contentful/live-preview/react"
    );

    return function Manager({
      fields,
    }: {
      fields: { entryId?: string; fieldId: string; targetSelector: string }[];
    }) {
      const { useEffect } = React;
      const inspectorMode = useContentfulInspectorMode();

      useEffect(() => {
        if (!inspectorMode) return;
        const cleanup: (() => void)[] = [];

        fields.forEach(({ entryId, fieldId, targetSelector }) => {
          if (!entryId || !fieldId) return;
          const el = document.querySelector(targetSelector);
          if (!el) return;

          const props: any = inspectorMode({
            entryId,
            fieldId,
          });
          const typedProps = props as Record<string, string>;

          Object.entries(typedProps).forEach(([key, value]) => {
            el.setAttribute(key, value);
            cleanup.push(() => el.removeAttribute(key));
          });
          cleanup.push(() =>
            Object.keys(props).forEach((k) => el.removeAttribute(k))
          );
        });

        return () => cleanup.forEach((fn) => fn());
      }, [fields, inspectorMode]);

      return null;
    };
  },
  {
    ssr: false,
    loading: () => null,
  }
);
